import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "platform" }
const _hoisted_3 = { class: "installs-uninstalls" }
const _hoisted_4 = { class: "installs" }
const _hoisted_5 = { class: "uninstalls" }
const _hoisted_6 = { class: "analytics-grid-2-cols" }
const _hoisted_7 = { class: "row-name" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "analytics-grid-2-cols" }
const _hoisted_11 = { class: "row-name" }
const _hoisted_12 = { class: "value" }

import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import AnalyticsCardOrganism from '../analytics-card/AnalyticsCardOrganism.vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionsAnalyticsOrganism',
  setup(__props) {

  const platform = ref('apple');

  const store = useStore();
  const dashboardAnalytics = computed(
    () => store.getters['dashboardAnalytics/getDashboardAnaylitics'],
  );

  const platformAnaylitics = computed(() => {
    if (dashboardAnalytics.value) {
      return dashboardAnalytics.value[platform.value];
    }
    return null;
  });

  const switchPlatform = (newPlatform: string) => {
    if (newPlatform === platform.value) {
      return;
    }
    platform.value = newPlatform;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _cache[3] || (_cache[3] = _createTextVNode(" Platform: ")),
        _createElementVNode("span", {
          class: _normalizeClass([
          'platform-active',
          { 'platform-inactive': platform.value !== 'apple' },
        ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (switchPlatform('apple')))
        }, "Apple", 2),
        _createElementVNode("span", {
          class: _normalizeClass([
          'platform-active',
          { 'platform-inactive': platform.value !== 'google' },
        ]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchPlatform('google')))
        }, "Google", 2),
        _createElementVNode("span", {
          class: _normalizeClass([
          'platform-active',
          { 'platform-inactive': platform.value !== 'total' },
        ]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (switchPlatform('total')))
        }, "All", 2)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "analytics-group-title" }, "Results", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" Installs: ")),
          _createElementVNode("span", _hoisted_4, _toDisplayString(platformAnaylitics.value?.installsVsUninstalls?.installs), 1)
        ]),
        _createElementVNode("h3", null, [
          _cache[5] || (_cache[5] = _createTextVNode(" Uninstalls: ")),
          _createElementVNode("span", _hoisted_5, _toDisplayString(platformAnaylitics.value?.installsVsUninstalls?.uninstalls), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformAnaylitics.value?.results, (result) => {
          return (_openBlock(), _createBlock(AnalyticsCardOrganism, {
            title: result.name,
            key: result.name,
            icon: "analyticsUsers",
            class: "analytics-card"
          }, {
            body: _withCtx(() => [
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result?.data, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.name
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.value), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "analytics-group-title" }, "Indicators", -1)),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformAnaylitics.value?.indicators, (indicator) => {
          return (_openBlock(), _createBlock(AnalyticsCardOrganism, {
            title: indicator.name,
            key: indicator.name,
            icon: "analyticsUsers",
            class: "analytics-card"
          }, {
            body: _withCtx(() => [
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicator?.data, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.name
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.value), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})